<template>
    <div>
        <el-table :data="copyQuestionsList" style="width: 100%;margin-top: 15px;margin-bottom: 35px;">
            <el-table-column type="expand">
                <template slot-scope="props">
                    <div class="props-div">
                        <el-checkbox-group v-model="props.row.checkList">
                            <el-checkbox v-for="(ite, ind) in props.row.value" :key="'check' + ind" :label="ite.id"
                                :disabled="ite.submitStatus == 1">
                                <div class="p-d-item">
                                    <p class="p-d-i-p">{{ ite.fourthIndicatorName }}
                                        <!-- <span class="p-d-i-s">{{ite.classify}}</span> -->
                                    </p>
                                </div>
                            </el-checkbox>
                        </el-checkbox-group>
                        <el-button type="primary" :disabled="props.row.checkList.length == 0 || props.row.status == 4"
                            @click="distribution(props.row.checkList)" style="margin-right: 20px;">重新分配</el-button>
                        <el-checkbox @change="allCheck($event, props.$index)" v-model="props.row.allChecked"
                            :disabled="props.row.value.length === 0 || props.row.status == 4">全选</el-checkbox>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="部门" prop="name">
            </el-table-column>
            <el-table-column label="操作" prop="desc">
                <template slot-scope="scope">
                    <div>
                        <el-button type="primary"
                            v-show="scope.row.status === 1 || scope.row.status === 2 || scope.row.status === 3"
                            @click="toTest(scope.row.name, 2)">填写</el-button>
                        <el-button style="margin-left: 0px;" v-show="scope.row.status === 3"
                            @click="submitQuestions(scope.row.value)">提交</el-button>
                        <el-button style="margin-left: 0px;" v-show="scope.row.status === 4"
                            @click="toViewQuestions(scope.row.name, 2)">查看</el-button>
                        <div v-show="scope.row.status === 0"></div>
                        <span @click="updateName(scope.row)" class="update-btn">修改名称</span>
                        <span @click="deleteDepartment(scope.row.id)" class="delete-btn">删除</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="进度" prop="total">
                <template slot-scope="scope">
                    <div class="table-progress">
                        <div class="table-progress-item">
                            <el-progress
                                :percentage="scope.row.total !== 0 ? (scope.row.progress / scope.row.total) * 100 : 0"
                                :show-text="false"></el-progress>
                        </div>
                        <span class="table-progress-span">
                            {{ scope.row.progress + '/' + scope.row.total }}
                        </span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="状态" prop="name">
                <template slot-scope="scope">
                    <span>{{ scope.row.status | statusFilter }}</span>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
import { autoFormApi } from '../../api/api-url/autoForm'
export default {
    name: 'DeparentQuestions',
    props: {
        questionsList: Array,
        infoId: Number
    },
    data() {
        return {
            copyQuestionsList: [],
            viewQuestions: true
        }
    },
    watch: {
        questionsList(news) {
            this.copyQuestionsList = news
        }
    },
    mounted() {

    },
    filters: {
        statusFilter(val) {
            switch (val) {
                case 0:
                    return '未配题'
                case 1:
                    return '未编辑'
                case 2:
                    return '编辑中'
                case 3:
                    return '待提交'
                case 4:
                    return '已提交'
            }
        }
    },
    methods: {
        updateName(val) {
            this.$emit('updateName', val)
        },
        deleteDepartment(val) {
            this.$emit('deleteDepartment', val)
        },
        async submitQuestionsApi(str) {
            let res = await autoFormApi.selectSubmit({
                questionIdList: str
            })
            if (res) {
                console.log(res);
            }
        },
        submitQuestions(list) {
            // console.log(list);
            let list2 = []
            for (const i in list) {
                list2.push(list[i].id)
            }
            const str = list2.join(',')
            // console.log(str);
            this.$confirm('确定提交?', '提示', {
                distinguishCancelAndClose: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.submitQuestionsApi(str)
                this.updateData()
                this.$message({
                    type: 'success',
                    message: `提交成功`
                });
            }).catch((action) => {
                if (action === 'cancel') {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                }
            });
        },
        updateData() {
            this.$emit('dataUpdated')
        },
        allCheck(val, index) {
            this.$emit('allCheck2', val, index)
        },
        distribution(arr) {
            this.$emit('distribution', arr)
        },
        toTest(name, type) {
            this.$router.push({
                name: 'TestPage',
                query: {
                    infoId: this.infoId,
                    name,
                    type,
                }
            });
        },
        //去查看题目页面
        toViewQuestions(name, type) {
            this.$router.push({
                name: 'ViewQuestionsPage',
                query: {
                    infoId: this.infoId,
                    name,
                    type,
                }
            });
        },
    }
}
</script>
<style lang="scss" scoped>
.props-div {
    padding-left: 20px;

    .el-checkbox-group {
        .el-checkbox {
            display: block;
            position: relative;
            margin: 5px 0;

            .p-d-item {
                .p-d-i-p {
                    .p-d-i-s {
                        position: absolute;
                        right: 5%;
                        top: center;
                        color: #3B9395;
                        width: 100px;
                    }
                }
            }
        }
    }
}

.table-progress {
    .table-progress-item {
        width: calc(100% - 62px);
        display: inline-block;
    }

    .table-progress-span {
        width: 50px;
        margin-left: 10px;
        display: inline-block;
    }
}

.update-btn {
    color: #3B9395;
    border-bottom: 1px solid #3B9395;
    cursor: pointer;
    margin-left: 10px;
}

.delete-btn {
    color: #FF3B3B;
    border-bottom: 1px solid #FF3B3B;
    cursor: pointer;
    margin-left: 10px;
}</style>